import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Card, Col, Row, Button, CardBody, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';
import * as constants from './constants'
import { Preloading } from '../../../components/UI/Preloader/action';
import { fetchCorporateCaseCount, listCorporate } from './action'
import Select from 'react-select';
import CaseCountTableView from './Table/index'
import { toast } from 'react-toastify';

class CorporateCaseCountComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: constants.ACTIVE,
            corporateList: [],
            selectedEntityData: [],
            corporateId: '',
            tableData: [],
            pageNo: 0,
            pageSize: 10
        };
    }

    componentDidMount() {
        this.props.listCorporate()
        this.props.preloading(true);
    }

    componentDidUpdate(prevProps) {
        const { corporateList, corporateListError, corporateCaseCountPaginatedData, corporateCaseCountFailure } = this.props
        if (corporateList !== prevProps.corporateList) {
            let corporateListArray = []
            corporateList.forEach(item => corporateListArray.push({ value: item.id, label: item.name }))
            this.setState({
                corporateList: corporateListArray,
                loading: false
            })
            this.props.preloading(false);
        }
        if (corporateListError !== prevProps.corporateListError) {
            this.props.preloading(false);
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp; {corporateListError.data}
                </div>
            );
        }
        if (corporateCaseCountPaginatedData != prevProps.corporateCaseCountPaginatedData) {
            this.setState({
                tableData: corporateCaseCountPaginatedData.data
            })
            this.props.preloading(false);
            console.log(corporateCaseCountPaginatedData.data)
        }
        if (corporateCaseCountFailure != prevProps.corporateCaseCountFailure) {
            this.props.preloading(false);
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp; {corporateCaseCountFailure.data}
                </div>
            );
        }
    }

    toggle = (tab) => {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            }, () => {
                if (this.state.corporateId !== '') {
                    if (this.state.activeTab === constants.ACTIVE) {
                        this.props.preloading(true)
                        this.prepareTableDataRequest(this.state.corporateId, this.state.activeTab, 0, this.state.pageSize)
                    } else if (this.state.activeTab === constants.INACTIVE) {
                        this.props.preloading(true)
                        this.prepareTableDataRequest(this.state.corporateId, this.state.activeTab, 0, this.state.pageSize)
                    }
                } else {
                    toast.error(
                        <div>
                            <i className="fa fa-exclamation-triangle"></i>&nbsp;Please select corporate name
                        </div>
                    );
                }
            });
        } else {
            this.props.preloading(false)
        }
    }

    selectedEntityCallback = (selectedData) => {
        this.setState({
            selectedEntityData: selectedData,
            corporateId: selectedData.value
        })
        this.prepareTableDataRequest(selectedData.value, this.state.activeTab, 0, this.state.pageSize)
    }

    prepareTableDataRequest = (corporateId, activeTab, pageNo, pageSize) => {
        const requestBody = {
            corporateId: corporateId === "" ? this.state.corporateId : corporateId,
            isActive: activeTab === constants.ACTIVE ? true : false,
            pageNo: pageNo,
            pageSize: pageSize
        };
        this.props.preloading(true);
        this.props.fetchCorporateCaseCount(requestBody);
    }

    render() {
        return (
            <Col>
                <Card>
                    <CardBody>
                        <Row className="mb-3 align-items-center">

                            <Col xs="3" className="filter-category py-0 py-sm-20">
                                <span className="filter-popover-header-item d-flex justify-content-between align-items-center mb-3 mb-sm-0">{"Corporate Name"}</span>
                            </Col>
                            <Col sm="9" className="filter-category py-sm-20">
                                <Select
                                    value={this.state.selectedEntityData}
                                    onChange={this.selectedEntityCallback}
                                    options={this.state.corporateList}
                                >
                                </Select>
                            </Col>
                        </Row>
                        <Nav tabs>
                            <NavItem>
                                <NavLink href="#"
                                    className={classnames({ active: this.state.activeTab === constants.ACTIVE })}
                                    onClick={() => { this.toggle(constants.ACTIVE); }}>
                                    Active
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="#"
                                    className={classnames({ active: this.state.activeTab === constants.INACTIVE })}
                                    onClick={() => { this.toggle(constants.INACTIVE); }}>
                                    InActive
                                </NavLink>
                            </NavItem>
                        </Nav>
                        <TabContent activeTab={this.state.activeTab}>
                            <TabPane tabId={constants.ACTIVE}>
                                <Row>
                                    <div className="col">
                                        <CaseCountTableView
                                            data={this.state.tableData}
                                            //loading={this.state.loading}
                                            activeTab={constants.ACTIVE}
                                            prepareTableDataRequest={this.prepareTableDataRequest}
                                        />
                                    </div>
                                </Row>
                            </TabPane>
                            <TabPane tabId={constants.INACTIVE}>
                                <Row>
                                    <div className="col">
                                        <CaseCountTableView
                                            data={this.state.tableData}
                                            //loading={this.state.loading}
                                            activeTab={constants.INACTIVE}
                                            prepareTableDataRequest={this.prepareTableDataRequest}
                                        />
                                    </div>
                                </Row>
                            </TabPane>
                        </TabContent>
                    </CardBody>
                </Card>
            </Col>
        )
    };
}
const mapStateToProps = (state, ownProps) => ({
    corporateList: state.CorporateCaseCountReducer.corporateList,
    corporateCaseCountPaginatedData: state.CorporateCaseCountReducer.corporateCaseCountPaginatedData,
    corporateListError: state.CorporateCaseCountReducer.corporateListError,
    corporateCaseCountFailure: state.CorporateCaseCountReducer.corporateCaseCountFailure
})

const mapDispatchToProps = (dispatch) => ({
    listCorporate: () => { dispatch(listCorporate()) },
    fetchCorporateCaseCount: (data) => { dispatch(fetchCorporateCaseCount(data)) },
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); }
});

export default connect(mapStateToProps, mapDispatchToProps)(CorporateCaseCountComponent);